"use strict";

function ResolutionChecker(options) {
  var self = {};
  self.loadedConfig = null;
  self.serverVersion = null;
  self.minWidth = 1280;
  self.maxWidth = 2560;
  self.minHeight = 800;
  self.maxHeight = 1440;
  Object.assign(self, options);

  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  self.mobile =
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
      userAgent
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      userAgent.substr(0, 4)
    );
  self.tablet =
    !self.mobile &&
    (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
      userAgent
    ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        userAgent.substr(0, 4)
      ));

  self.checkResolution = function () {
    if (self.mobile || self.tablet) {
      return;
    }
    if (
      self.maxWidth < window.innerWidth ||
      self.maxHeight < window.innerHeight
    ) {
      self.showToast(false);
    } else if (
      self.minWidth > window.innerWidth ||
      self.minHeight > window.innerHeight
    ) {
      self.showToast(true);
    } else {
      self.hideToast();
    }
  };

	const containerStyles = {
    position : "fixed",
		display: "flex",
		flexWrap: "wrap",
    gap : "10px",
    left: "0",
    bottom: "0",
    padding: "10px",
    zIndex : "999999",
  }

  const toastStyles = {
    display : "flex",
    width: "400px",
    margin : "0",
    fontFamily: "Helvetica, serif",
    fontSize: "12px",
    padding : "10px",
    opacity : "1",
    borderRadius : "5px",
    color: "#333A4A",
    background: "#fff4e5",
    gap : "10px",
    alignItems : "center",
		whiteSpace: "nowrap",
		boxShadow: "0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)"
  }
  
  const toastHide = {
    display: "none"
    
  }
  
  const toastShow = {
    display: "flex"
	}

  self.ensureElements = function () {
    if (!self.container) {
      self.container = document.getElementById("network-toast-container");
      if (!self.container) {
        self.container = document.createElement("div");
        self.container.id = "network-toast-container";
        Object.assign(self.container.style, containerStyles)
        document.body.appendChild(self.container);
      }
    }
    if (!self.toastElement) {
      self.toastElement = document.getElementById(
        "toast-resolution-checker-container"
      );
      if (!self.toastElement) {
        self.toastElement = document.createElement("div");
        self.toastElement.id = "toast-resolution-checker-container";
        Object.assign(self.toastElement.style, toastStyles, toastHide)
        self.toastElement.innerHTML =
          '<svg focusable="false" width="20px" height="20px" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"></path></svg>'+
          '<span></span>';
        self.container.appendChild(self.toastElement);
      }
    }
  };

  self.showToast = function (smaller) {
    
    self.ensureElements();

    window.setTimeout(function () {
      self.toastElement.children[1].innerHTML =
        `<b>Your browser resolution is too ${smaller ? "small" : "large"}.</b>
         <br/>You may need to adjust your browser zoom level.`;
         Object.assign(self.toastElement.style, toastShow)

      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (
        !self.mobile &&
        userAgent.indexOf("Mac OS X") >= 0 &&
        navigator.maxTouchPoints > 0
      ) {
        self.toastElement.children[1].innerHTML =
        `<b>Your browser resolution is too ${smaller ? "small" : "large"}.</b>
         <br/>You may need to adjust your browser zoom level.
         <br/>You may need to adjust your browser zoom level.<br/>This message may appear erroneously on iPads."`
        if (self.hideTimeout) {
          clearTimeout(self.hideTimeout);
        }
        self.hideTimeout = setTimeout(self.hideToast, 10000);
      }
    }, 100);
  };

  self.hideToast = function () {
    if (self.toastElement) {
      Object.assign(self.toastElement.style, toastHide)
    }
  };

  window.addEventListener("resize", self.checkResolution);
  setTimeout(self.checkResolution, 500);

  window.changeResolutionTarget = function (winWidth, maxWidth, minHeight, maxHeight) {
    self.minWidth = winWidth;
    self.maxWidth = maxWidth;
    self.minHeight = minHeight;
    self.maxHeight = maxHeight;
    self.checkResolution();
  }
}

ResolutionChecker({});